import { HttpClient, HttpParams } from "@angular/common/http"
import { Injectable } from "@angular/core"
import { environment } from "environments/environment"
import { Observable } from "rxjs"

export class ApiPaths {
  public static applications = "applications"
  public static integrations = "integrations"
  public static authToken = "auth/token"
  public static authTokenRefresh = "auth/token/refresh"
  public static companies = "companies"
  public static users = "users"

  public static companyUser(companyId: string): string {
    return `${ApiPaths.companies}/${companyId}/${ApiPaths.users}`
  }

  public static companyUserById(companyId: string, uid: string): string {
    return `${ApiPaths.companies}/${companyId}/${ApiPaths.users}/${uid}`
  }
}

@Injectable({providedIn: "root"})
export class ApiService {
  private baseUrl = environment.api.url
  constructor(private httpClient: HttpClient) { }

  public async head<ReturnData = any>(relativeUrl: string, params?: any): Promise<ReturnData> {
    return this.httpClient.head(`${this.baseUrl}/${relativeUrl}`, {
      params: this.toHttpParams(params),
    }).toPromise() as Promise<ReturnData>
  }

  public async get<ReturnData = any>(relativeUrl: string, params?: any): Promise<ReturnData> {
    return this.httpClient.get<ReturnData>(`${this.baseUrl}/${relativeUrl}`, {
      params: this.toHttpParams(params),
    }).toPromise()
  }

  public async post<BodyData = any, ReturnData = BodyData>(
    relativeUrl: string, body: BodyData, params: any = {}, headers: any = {},
  ): Promise<ReturnData> {
    return this.post$(relativeUrl, body, params, headers).toPromise()
  }

  public post$<BodyData = any, ReturnData = any>(
    relativeUrl: string, body: BodyData, params: any = {}, headers: any = {},
  ): Observable<ReturnData> {
    return this.httpClient.post<ReturnData>(`${this.baseUrl}/${relativeUrl}`, body, {
      params: this.toHttpParams(params),
      headers,
    })
  }

  public async put<BodyData = any, ReturnData = any>(
    relativeUrl: string, body: BodyData, params?: any,
  ): Promise<ReturnData> {
    return this.httpClient.put<ReturnData>(`${this.baseUrl}/${relativeUrl}`, body, {
      params: this.toHttpParams(params),
    }).toPromise()
  }

  public async patch<BodyData = any, ReturnData = any>(
    relativeUrl: string, body: BodyData, params?: any,
  ): Promise<ReturnData> {
    return this.httpClient.patch<ReturnData>(`${this.baseUrl}/${relativeUrl}`, body, {
      params: this.toHttpParams(params),
    }).toPromise()
  }

  public async delete(relativeUrl: string, id: string): Promise<any> {
    return this.httpClient.delete(`${this.baseUrl}/${relativeUrl}/${id}`).toPromise()
  }

  private toHttpParams(params?: any): HttpParams {
    if (params === null || params === undefined) {
      return null
    }
    return Object.getOwnPropertyNames(params)
      .reduce((param, key) => param.set(key, params[key]), new HttpParams())
  }
}
